import './index.scss';

export default {
    name: 'chj-message',
    data() {
        return {
            show: false,
            type: 'info',
            message: '',
            duration: 3000,
            iconClass: 'iconfont-message-info'
        };
    },
    mounted() {
        this.startTimer();
        this.iconClass = `iconfont-message-${this.type}`;
    },
    methods: {
        startTimer() {
            if (this.duration > 0) {
                this.timer = setTimeout(() => {
                    this.show = false;
                }, this.duration);
            }
        }
    }
};
